<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Though volumes have been written about the Indian Wars and the settlement of the post–Civil War West, the great majority of them overlook the service of the Black troops, the Buffalo Soldiers. There is scant mention in books by well-known historians like George Bird Grinnell in <i>The Fighting Cheyennes</i> or Robert Utley in <i>Frontier Regulars: The United States Army and the Indians, 1866–1891</i>. In 1967, William Leckie published <i>The Buffalo Soldiers: A Narrative of the Black Cavalry in the West</i>, which created the first interest in the Black troops. However, Leckie focused on the Ninth and Tenth Cavalries and their pursuit of Native Americans in Texas and the Southwest. There was little written about the Black infantrymen until Monroe Billington wrote <i>The Buffalo Soldiers of New Mexico: 1866–1900</i>. There are no books about the conflicts of the Buffalo Soldiers with the Utes in the Rocky Mountains or their fierce battles with the Cheyenne, Arapaho, and Sioux on the plains of Colorado.</p>
<p class="indent">Much appreciation goes to the regional historical societies and librarians for information about the Buffalo Soldiers who served in their areas. Their collections of bullets, arrowheads, cavalry buttons, and artifacts gathered at battle sites and abandoned villages are remnants of that turbulent time.</p>
<p class="indent">My thanks to History Colorado, the White River Museum in Meeker, the Ute Indian Museum, and the Fort Garland Museum.</p>
<p class="indent">Thank you to Tom Williams, whose skill with the camera captured the lonely battlefields where the ghosts of men who fought still linger.</p>
<p class="indent">A special thanks to Artie Crisp, senior acquisitions editor at The History Press.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?6450f3e2